export {hosts} from "../../dicts/hosts";
